// 管理后台路由（全部 requiresAuth: true）
export default [
    {
        path: '/admin',
        name: 'routerPagesRoot',
        component: () => import( /* webpackChunkName: "routerPages" */  '@/components/theLogin/routerPages.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/admin/ssoLogin',
        name: 'ssoLogin',
        component: () => import(/* webpackChunkName: "ssoLogin" */ '@/components/theLogin/ssoLogin.vue'),
        meta: { requiresAuth: false }
    },
    {
        path: '/admin',
        name: 'admin',
        component: () => import( /* webpackChunkName: "admin" */ '@/components/admin.vue'),
        // redirect: '/admin/first-page',
        children: [
            {
                path: 'first-page',
                name: 'firstPage',
                component: () => import(/* webpackChunkName: "firstPage" */  '@/admin/home/firstPage.vue'),
                meta: { requiresAuth: true },
            },
            {
                path: 'form-configuration',
                name: 'formConfiguration',
                component: () => import(/* webpackChunkName: "formConfiguration" */ '@/admin/formConfiguration/formRoute.vue'),
                meta: { requiresAuth: true },
            },
            {
                path: 'form-configuration/form-set',
                name: 'formSet',
                component: () => import(/* webpackChunkName: "formSet" */ '@/admin/formConfiguration/formSet.vue'),
                meta: { requiresAuth: true },
            },
            {
                path: 'faq',
                name: 'faqList',
                component: () => import(/* webpackChunkName: "faqList" */  '@/admin/faqPages/faqList.vue'),
                meta: { requiresAuth: true },
            },
            {
                path: 'announcement',
                name: 'noticePage',
                component: () => import(/* webpackChunkName: "noticePage" */ '@/admin/notice/noticePage.vue'),
                meta: { requiresAuth: true },
            },
            {
                path: 'logRecord',
                name: 'logRecord',
                component: () => import(/* webpackChunkName: "logRecord" */ '@/admin/logsPage/logRecord.vue'),
                meta: { requiresAuth: true },
            },
            {
                path: 'management',
                name: 'staffManagement',
                component: () => import(/* webpackChunkName: "staffManagement" */  '@/admin/management/staffManagement.vue'),
                meta: { requiresAuth: true },
            },
            {
                path: 'count-list',
                name: 'countList',
                component: () => import(/* webpackChunkName: "countList" */  '@/admin/countList/countList.vue'),
                meta: { requiresAuth: true },
            },

            {
                path: 'service-request-form-display',
                name: 'serviceRequestFormDisplay',
                component: () => import(/* webpackChunkName: "serviceRequestFormDisplay" */  '@/admin/serviceRequestFormDisplay/serviceRequestFormDisplay.vue'),
                meta: { requiresAuth: true },
            },
            {
                path: 'service-request-type',
                name: 'serviceType',
                component: () => import(/* webpackChunkName: "serviceType" */ '@/admin/serviceType/serviceType.vue'),
                meta: { requiresAuth: true },
            },
            // {
            //     path: 'routerPages',
            //     name: 'routerPages',
            //     component: () => import('@/components/theLogin/routerPages.vue'),
            //     meta: { requiresAuth: true },
            // },

        ]
    },

    {
        path: '/admin/change-password',
        name: 'ChangePassword',
        component: () => import(/* webpackChunkName: "changePassword" */ '@/components/theLogin/changePassword.vue'),
        meta: { requiresAuth: true }, // 这里允许不登录访问改密页
    },
    {
        path: '/admin/forget-password',
        name: 'forgetPassword',
        component: () => import(/* webpackChunkName: "forgotPassword" */ '@/components/theLogin/forgotPassword.vue'),
        meta: { requiresAuth: false }, // 这里允许不登录访问改密页
    },
    {
        path: '/admin/return-password',
        name: 'returnPassword',
        component: () => import(/* webpackChunkName: "returnPassword" */ '@/components/theLogin/returnPassword.vue'),
        meta: { requiresAuth: false }, // 这里允许不登录访问改密页
    },
    {
        path: '/admin/eNotification',
        name: 'eNotification',
        component: () => import( /* webpackChunkName: "eNotification" */ '@/components/eNotification.vue'),
        children: [
            {
                path: 'IRR/AdHoc-IRR',
                name: 'createAdhocIrr',
                component: () => import(/* webpackChunkName: "createAdhocIrr" */ '@/eNotification/IRR/createAdhocIrr.vue'),
                meta: { requiresAuth: true },
            },
            {
                path: 'IRR/Scarf-IRR',
                name: 'createScarfIrr',
                component: () => import(/* webpackChunkName: "createScarfIrr" */ '@/eNotification/IRR/createScarfIrr.vue'),
                meta: { requiresAuth: true },
            },
            {
                path: 'IRR/Contact-List',
                name: 'contactList',
                component: () => import(/* webpackChunkName: "contactList" */ '@/eNotification/IRR/contactList.vue'),
                meta: { requiresAuth: true },
            },
            {
                path: 'IRR/irr-status',
                name: 'irrStatus',
                component: () => import(/* webpackChunkName: "irrStatus" */ '@/eNotification/IRR/irrStatus/irrStatus.vue'),
                meta: { requiresAuth: true },
            },
            {
                path: "IRR/irr-user",
                name: "IrrUser",
                component: () => import(/* webpackChunkName: "irrUser" */  "@/eNotification/IRR/irrStatus/irrUser.vue"),
                meta: { requiresAuth: true },
            },
            {
                path: "IRR/irr-search",
                name: "irrSearch",
                component: () => import(/* webpackChunkName: "irrSearch" */  "@/eNotification/IRR/irrSearch.vue"),
                meta: { requiresAuth: true },
            },
            {
                path: "IRR/irr-files",
                name: "irrFiles",
                component: () => import(/* webpackChunkName: "irrFiles" */ "@/eNotification/IRR/irrFiles.vue"),
                meta: { requiresAuth: true },
            },
            {
                path: "Non-Irr",
                name: "nonIrr",
                component: () => import(/* webpackChunkName: "nonIrr" */ "@/eNotification/nonIrr/nonIrr.vue"),
                meta: { requiresAuth: true },
            }, {
                path: "Non-Irr-user",
                name: "nonIrrUser",
                component: () => import(/* webpackChunkName: "nonIrrUser" */ "@/eNotification/nonIrr/nonIrrUser.vue"),
                meta: { requiresAuth: true },
            },
            {
                path: 'management-templates',
                name: 'templateIndex',
                component: () => import(/* webpackChunkName: "templateIndex" */ '@/eNotification/managementTemplates/templateIndex.vue'),
                meta: { requiresAuth: true },
            },
            {
                path: 'compensations-manager',
                name: 'compensationsManager',
                component: () => import(/* webpackChunkName: "compensationsManager" */ '@/eNotification/compensations/compensationsManager.vue'),
                meta: { requiresAuth: true },
            },
            {
                path: 'natures-manager',
                name: 'naturesIndex',
                component: () => import(/* webpackChunkName: "naturesIndex" */ '@/eNotification/natures/naturesIndex.vue'),
                meta: { requiresAuth: true },
            },
            {
                path: 'notification',
                name: 'Notification',
                component: () => import(/* webpackChunkName: "notificationIndex" */ '@/eNotification/notification/notificationIndex.vue'),
                meta: { requiresAuth: true },
            },
            {
                path: 'air-ports',
                name: 'airPorts',
                component: () => import(/* webpackChunkName: "airPorts" */ '@/eNotification/airPorts/airPorts.vue'),
                meta: { requiresAuth: true },
            },
        ]
    },
    {
        path: '/admin/survey/survey-list',
        name: 'survey',
        component: () => import(/* webpackChunkName: "surveyList" */ '@/survey/surveyList.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/admin/the-login',
        name: 'theLogin',
        component: () => import( /* webpackChunkName: "theLogin" */'@/components/theLogin/theLogin.vue'),
        meta: { requiresAuth: false },
    },
];